<div class="font-selector-comp">
  <div class="font-selector-component-header">
    <span class="font-output" [ngStyle]="getStyles()">Sample Text</span>
    <button type="button" class="btn btn-default btn-sm p-dropdown-trigger-icon">
      <i
        class="pi pi-pencil"
        (click)="op.show($event)"
        (keyup.enter)="op.show($event)"
        tabindex="0"
        aria-label="Show popup"
      ></i>
    </button>
  </div>
  <p-popover #op>
    <ng-template #content>
      <form [formGroup]="formGroup">
        <div class="form-group row mb-1">
          <label for="fontFamily" class="col-4 col-form-label">Font Family</label>
          <div class="col-8">
            <p-select
              [options]="fontFamilies"
              formControlName="fontFamily"
              [editable]="true"
              optionLabel="name"
              [showClear]="true"
              [appendTo]="'body'"
              [disabled]="disableField"
            ></p-select>
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="fontSize" class="col-4 col-form-label">Font Size</label>
          <div class="col-8">
            <!-- <input type="text" class="form-control" id="fontFamily" formControlName="fontSize"> -->
            <vb-size
              formControlName="fontSize"
              [currentPage]="currentPage"
              [disabled]="disableField"
              [isTemplateFontGroup]="isTemplateFontGroup"
              [disableField]="disableField"
            ></vb-size>
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="fontWeight" class="col-4 col-form-label">Font Weight</label>
          <div class="col-8">
            <p-select
              [options]="fontWeights"
              formControlName="fontWeight"
              optionLabel="name"
              [appendTo]="'body'"
              [disabled]="disableField"
            >
            </p-select>
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="fontStyle" class="col-4 col-form-label">Font Style</label>
          <div class="col-8">
            <p-select
              [options]="fontStyles"
              formControlName="fontStyle"
              optionLabel="name"
              [appendTo]="'body'"
              [disabled]="disableField"
            >
            </p-select>
          </div>
        </div>
        <div class="form-group row mb-1" *ngIf="currentPage?.currentPage !== 'templates'">
          <label for="fontColor" class="col-4 col-form-label">Font Color</label>
          <div class="col-8">
            <input
              type="color"
              class="form-control"
              id="fontColor"
              formControlName="fontColor"
              [disabled]="disableField"
            />
          </div>
        </div>
        <div class="button-group text-right mt-3">
          <button class="btn btn-secondary btn-sm mr-1" (click)="op.hide($event)">Cancel</button>
          <button class="btn btn-primary btn-sm" (click)="handleFontChanges($event, op)" [disabled]="disableField">
            Save
          </button>
        </div>
      </form>
    </ng-template>
  </p-popover>
</div>
